import { SelectCompanyForm } from "../components/select-company-form";

export const SelectCompanyPage: React.FC = () => {
  return <SelectCompanyForm />;
};
